module.exports = __webpack_public_path__ + "static/unidad_central-7d9c45ffb7dfab99f8364ddc760befa7.png";